<template>
  <div class="header">
    <a-row type="flex" justify="start" align="middle" class="user-info-container">
      <a-col :span="24">
        <a-avatar icon="user" class="user-icon user-info-element" />
        <p class="no-margin user-info-element">{{ user.fullname }}</p>
        <p v-if="user.permissionLevel === 0" class="no-margin user-info-element user-info-classroom">({{ user.classroom }})</p>
      </a-col>
    </a-row>
    <a-row type="flex" justify="center" align="middle">
      <a-col :span="24">
        <template v-if="selectedWork">
          <div class="text-center">
            <template v-if="hasWorkCommentBeenRead">
              <a-tooltip placement="top" >
                <template slot="title">
                  <span>Votre travail a fait l'objet d'un commentaire, cliquez pour voir</span>
                </template>
                <a-icon @click="handleShowCommentWorkModal" class="inline show-comment-icon" type="message" />
              </a-tooltip>
            </template>
            <template v-else-if="user.permissionLevel === 1 && selectedWork.remarque">
              <a-tooltip placement="top" >
                <template slot="title">
                  <span>Un commentaire a été apposé sur ce travail. Rendez-vous dans "Commenter" (barre latérale) pour le consulter / modifier</span>
                </template>
                <a-icon class="inline show-comment-icon-teacher" type="message" />
              </a-tooltip>
            </template>
            <h1 class="inline detail-name" :class="{ 'dark-theme-font': darkTheme }">
              Détails de :
              <p class="work-label inline" @keyup.enter="handleKeyUpEnter" @blur="handleLeaveField" contenteditable="true">
                {{ selectedWork.titreTravail }}
              </p>
              <a-icon class="work-label-icon inline" type="edit" />
            </h1>
          </div>
          <div class="text-center">
            <p class="detail-description no-margin inline">Total de {{ totalWorkPeriods }} période(s) créé le {{ selectedWork.dateCreation }}</p>
            <template v-if="user.permissionLevel === 1">
              <p class="no-margin inline"> par </p>
              <p class="detail-owner no-margin inline">{{ selectedWork.loginCreateur }} ({{ selectedWork.classeCreateur }})</p>
            </template>
          </div>
        </template>
        <template v-else>
          <h1 class="detail-name text-center" :class="{ 'dark-theme-font': darkTheme }">Journal de travail</h1>
        </template>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import WorkService from '../services/work_service'

export default {
  name: 'Header',
  props: {
    fullname: String,
    classroom: String
  },
  methods: {
    handleKeyUpEnter (event) {
      event.target.blur()
    },
    async handleLeaveField (event) {
      const text = event.target.innerText
      event.target.innerText = text
      if (text.match('^\\s*$')) {
        this.$message.error('Ne doit pas être vide')
        event.target.innerText = this.selectedWork.titreTravail
        return
      }
      if (text.match(/^[0-9\s]*$/)) {
        this.$message.error('Ne doit pas contenir uniquement des chiffres')
        event.target.innerText = this.selectedWork.titreTravail
        return
      }
      if (text.length > 30) {
        this.$message.error('Ne doit pas contenir plus de 30 caractères')
        event.target.innerText = this.selectedWork.titreTravail
        return
      }
      const params = {
        numero: this.selectedWork.numero,
        titreTravail: event.target.innerText
      }
      const response = await WorkService.editWork(params)
      if (response) {
        this.$message.success('Travail renommé')
        Object.assign(this.selectedWork, params)
      }
    },
    handleShowCommentWorkModal () {
      this.$info({
        title: 'Votre travail a fait l\'objet d\'un nouveau commentaire :',
        maskClosable: true,
        width: 700,
        content: (
          <div>
            <pre style="text-align: justify; white-space: pre-wrap; margin-top: 30px;">
              { this.selectedWork.remarque }
            </pre>
          </div>
        )
      })
    }
  },
  computed: {
    ...mapState({
      darkTheme: state => state.darkTheme,
      user: state => state.auth.user,
      detailsData: state => state.detail.detailsData,
      worksData: state => state.work.worksData,
      selectedWork: state => state.work.selectedWork,
      seenComments: state => state.work.seenComments
    }),
    totalWorkPeriods: function () {
      return Array.isArray(this.detailsData) && this.detailsData.length ? this.detailsData.map(item => item.nbPeriodes).reduce((prev, next) => prev + next) : 0
    },
    hasWorkCommentBeenRead: function () {
      if (this.selectedWork) {
        // On check que le commentaire du travail sélectionné ait été lu
        const newData = [...this.seenComments]
        const target = newData.filter(item => this.selectedWork.numero === item.numero)[0]
        return target
      }
      return false
    }
  }
}
</script>

<style scoped lang="scss">
.work-label {
  cursor: text;
}
.show-comment-icon-teacher{
  font-size: 23px;
  cursor: unset;
}
.show-comment-icon{
  font-size: 23px;
  cursor: pointer;
}
// Affiche l'icon de modification lors du survol du label
.work-label:hover + .work-label-icon{
  position: static;
  opacity: 1;
  transition: opacity 0.5s linear;
}
// L'icon de modification reste affiché lorsque le champs est focus
.work-label:focus + .work-label-icon {
  position: static;
  opacity: 1;
}
.work-label-icon{
  position:absolute;
  opacity: 0;
  font-size: 25px;
}
.user-icon{
  margin-left: 0.5em;
  margin-right: 1em;
}
.user-info-container{
  padding-top: 5px;
}
.user-info-element{
  display: inline-block;
}
.user-info-classroom{
  margin-left: 5px;
}
.detail-name{
  cursor: default;
  font-size: 35px;
  margin-bottom: 5px;
  font-weight: bold;
}
.detail-description{
  font-size: 15px;
}
.detail-owner{
  font-weight: bold;
}
</style>
